package org.example.site_web.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import org.example.site_web.aiPalette
import org.example.site_web.components.images.AccTriangleIcon
import org.example.site_web.components.layouts.PageLayoutData
import org.example.site_web.content.page.offersContent_Manifest1
import org.example.site_web.content.page.offersContent_Manifest2
import org.example.site_web.content.page.offersContent_Part2
import org.example.site_web.content.page.offersContent_Part3
import org.example.site_web.content.page.offersContent_Part3List
import org.example.site_web.content.page.offersContent_Part4
import org.example.site_web.content.page.offersContent_Part4List
import org.example.site_web.content.page.offersContent_Part5
import org.example.site_web.content.page.offersContent_Part5List
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

val offersPageStyle = CssStyle {

    base {
        Modifier
            .fillMaxWidth()
            .fillMaxHeight()
            .padding(left=3.vw,right = 3.vw)
            .fontSize(1.cssRem)
    }

    Breakpoint.MD {
        Modifier.padding(leftRight = 10.vw)
    }

    Breakpoint.LG {
        Modifier.padding(leftRight = 15.vw)
    }

    Breakpoint.XL{
        Modifier.padding(leftRight = 22.vw)
    }

}

val manifestStyle = CssStyle {
    base {
        Modifier
            .border(color = aiPalette.optPalette.primary, style = LineStyle.Solid, width = 1.px)
            .boxShadow(spreadRadius = 0.25.em, blurRadius = 0.25.em, color = aiPalette.optPalette.primary, inset = false)
            .padding(1.5.cssRem)
            .margin(topBottom = 1.5.cssRem)
    }
}

@InitRoute
fun initOffers3Page(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Notre Offre"))
}


@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun Offers3Page() {

    Column(
        offersPageStyle.toModifier(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.SpaceAround
    ) {

        Box(
            Modifier
                .fillMaxWidth()
                .fontSize(2.0.cssRem)
                .fontWeight(FontWeight.Bold)
                .margin(top = 1.5.cssRem),
            contentAlignment = Alignment.BottomStart
        ) {
            Span() {
                AccTriangleIcon()
                Text("Notre Offre")
            }
        }

        Box(
            manifestStyle.toModifier()
                .fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            Span(
                Modifier
                    .textAlign(TextAlign.Center).toAttrs()
            ) {
                Text(offersContent_Manifest1)
            }
        }

        Box(
            Modifier
                .fillMaxWidth()
                .margin(topBottom = 1.5.cssRem),
            contentAlignment = Alignment.Center
        ) {
            Span(
                Modifier.textAlign(TextAlign.Center)
                    .textDecorationLine(TextDecorationLine.Underline).toAttrs()
            ) {
                Text(offersContent_Part2)
            }
        }

        Column(
            Modifier
                .borderRight {
                    color(aiPalette.mainPalette.darkest)
                    width(0.55.cssRem)
                    style(LineStyle.Solid)
                }
                .borderLeft {
                    color(aiPalette.mainPalette.darkest)
                    width(0.55.cssRem)
                    style(LineStyle.Solid)
                }
                .margin(topBottom = 1.5.cssRem)
                .padding(leftRight = 1.cssRem),
        ) {
            Span() {
                Text(offersContent_Part3)
            }
            Ul() {
                for (entry in offersContent_Part3List) {
                    Li() {
                        Span() {
                            Text(entry)
                        }
                    }
                }
            }
        }

        Box(
            manifestStyle.toModifier().fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            Span(
                Modifier
                    .textAlign(TextAlign.Center).toAttrs()
            ) {
                Text(offersContent_Manifest2)
            }
        }


        Column(
            Modifier.margin(topBottom = 1.5.cssRem).fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Span(Modifier.textAlign(TextAlign.Center).toAttrs()) {
                Text(offersContent_Part4)
            }
            Column(
                Modifier.margin(top = 1.5.cssRem).width(20.cssRem),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                for (entry in offersContent_Part4List) {
                    Box(
                        Modifier
                            .fillMaxWidth()
                            .backgroundColor(Colors.Black)
                            .color(Colors.White)
                            .border(color = aiPalette.mainPalette.primary, style = LineStyle.Solid, width = 0.2.cssRem)
                            .margin(topBottom = 0.75.cssRem)
                            .padding(leftRight = 1.5.cssRem, topBottom = 0.75.cssRem),
                        contentAlignment = Alignment.Center
                    ) {
                        Span(Modifier.textAlign(TextAlign.Center).toAttrs()) {
                            Text(entry)
                        }
                    }
                }
            }
        }

        Box(
            Modifier.margin(topBottom = 1.5.cssRem).fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            Span(
                Modifier
                    .fontSize(1.2.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .textAlign(TextAlign.Center).toAttrs()
            ) {
                Text(offersContent_Part5)
            }
        }

        Column(
            Modifier
                .padding(1.5.cssRem)
                .border(color = aiPalette.comPalette.darkest, style = LineStyle.Solid, width = 0.25.cssRem)
                .margin(top = 2.cssRem, bottom = 1.5.cssRem),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Span(Modifier
                .margin(bottom = 1.5.cssRem)
                .fontWeight(FontWeight.Bold).toAttrs()) {
                Text("Exemples de sujets et projets que nous pouvons réaliser")
            }
            for (entry in offersContent_Part5List) {
                Box(Modifier.margin(topBottom = 1.cssRem),
                    contentAlignment = Alignment.Center) {
                        Span(Modifier.textAlign(TextAlign.Center).toAttrs()) {
                            AccTriangleIcon(Modifier.attr("fill","white"))
                            Span(Modifier.fontWeight(FontWeight.Bold).toAttrs()) {Text(entry.first)}
                            Br()
                            Span(Modifier.whiteSpace(WhiteSpace.PreWrap).toAttrs()) {
                                Text(entry.second)
                            }
                            Br()
                        }

                }
            }
        }
    }
}
